var _excluded = ["type", "illustrationName"];

function cov_16hnvlryli() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/Illustration/Illustration.tsx";
  var hash = "f7173e9748e2a538bdbc90b79cb638e2ad167a29";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/Illustration/Illustration.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 26
        },
        end: {
          line: 27,
          column: 10
        }
      },
      "1": {
        start: {
          line: 29,
          column: 26
        },
        end: {
          line: 37,
          column: 10
        }
      },
      "2": {
        start: {
          line: 39,
          column: 31
        },
        end: {
          line: 55,
          column: 10
        }
      },
      "3": {
        start: {
          line: 57,
          column: 33
        },
        end: {
          line: 57,
          column: 82
        }
      },
      "4": {
        start: {
          line: 61,
          column: 67
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "5": {
        start: {
          line: 84,
          column: 67
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "6": {
        start: {
          line: 94,
          column: 77
        },
        end: {
          line: 110,
          column: 1
        }
      },
      "7": {
        start: {
          line: 112,
          column: 81
        },
        end: {
          line: 117,
          column: 1
        }
      },
      "8": {
        start: {
          line: 119,
          column: 26
        },
        end: {
          line: 124,
          column: 1
        }
      },
      "9": {
        start: {
          line: 146,
          column: 57
        },
        end: {
          line: 152,
          column: 1
        }
      },
      "10": {
        start: {
          line: 147,
          column: 14
        },
        end: {
          line: 149,
          column: 30
        }
      },
      "11": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 56
        }
      },
      "12": {
        start: {
          line: 151,
          column: 2
        },
        end: {
          line: 151,
          column: 47
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 146,
            column: 57
          },
          end: {
            line: 146,
            column: 58
          }
        },
        loc: {
          start: {
            line: 146,
            column: 99
          },
          end: {
            line: 152,
            column: 1
          }
        },
        line: 146
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 147,
            column: 36
          },
          end: {
            line: 147,
            column: 37
          }
        },
        loc: {
          start: {
            line: 147,
            column: 42
          },
          end: {
            line: 149,
            column: 3
          }
        },
        line: 147
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 148,
            column: 11
          },
          end: {
            line: 148,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 148,
            column: 11
          },
          end: {
            line: 148,
            column: 49
          }
        }, {
          start: {
            line: 148,
            column: 53
          },
          end: {
            line: 148,
            column: 55
          }
        }],
        line: 148
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f7173e9748e2a538bdbc90b79cb638e2ad167a29"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_16hnvlryli = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_16hnvlryli();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Image } from '@opendoor/bricks/core'; // All these images are taken from https://www.figma.com/file/w3nEyANoniTZdjz8kCUaDS/Eero-Design-System-(WIP)?node-id=26%3A685

export var SPOT_NAMES = (cov_16hnvlryli().s[0]++, ['Envelope-Money', 'File-Success', 'Search-Trends', 'Move', 'Secure', 'Envelope-Time', 'Map-Floorplan', 'Search-Files', 'Open House', 'Human', 'Envelope-Contract', 'Document-Sign', 'Search-Homes', 'Map-Home', 'Envelope-Document', 'Video Walkthrough', 'Apartment', 'Renovate', 'House-PriceUp', 'House-Worth']);
export var HERO_NAMES = (cov_16hnvlryli().s[1]++, ['Housing Appreciation 1', 'Housing Appreciation 2', 'Use Location', 'Calculate House Worth', 'Moving Homes 1', 'Moving Homes 2', 'Housing Appreciation 3']);
export var MIX_MATCH_NAMES = (cov_16hnvlryli().s[2]++, ['People/Celebrate-1', 'People/Celebrate-2', 'People/Celebrate-3', 'People/Celebrate-4', 'People/Celebrate-5', 'People/Celebrate-6', 'People/Multi-1', 'People/Multi-2', 'People/Multi-3', 'People/Multi-4', 'People/Dog', 'People/UI-1', 'People/UI-2', 'People/UI-3', 'People/UI-4']);
export var EMPTY_STATE_NAMES = (cov_16hnvlryli().s[3]++, ['Home 1', 'Home 2', 'Home 3', 'Home 4']);
var SPOT_IMAGE_DATA = (cov_16hnvlryli().s[4]++, {
  'Envelope-Money': 'https://imgdrop.imgix.net/244a5649bfc649f59154dc1ea026c124.png',
  'File-Success': 'https://imgdrop.imgix.net/191c55b76161437fb9f1ccd45c785503.png',
  'Search-Trends': 'https://imgdrop.imgix.net/e89b89d52389456ab0cd786f6a1ecf2f.png',
  Move: 'https://imgdrop.imgix.net/ca8958cb5c674ace88a3e28d52f310cb.png',
  Secure: 'https://imgdrop.imgix.net/d6686c6252af4d67a8eb77a8076ee59a.png',
  'Envelope-Time': 'https://imgdrop.imgix.net/9a37a6ebe56e462cade0fc461471019d.png',
  'Map-Floorplan': 'https://imgdrop.imgix.net/532efd095a364c0d95cf00c709e4e096.png',
  'Search-Files': 'https://imgdrop.imgix.net/0bdfe119ffb8450a94b78055217dc06d.png',
  'Open House': 'https://imgdrop.imgix.net/afa8b395f9844913b9fc5c3a933f789d.png',
  Human: 'https://imgdrop.imgix.net/2a336191ec374e438d7d0f57f86e0d98.png',
  'Envelope-Contract': 'https://imgdrop.imgix.net/a94d00b9d4574ad5b9d3ff86a76c7dae.png',
  'Document-Sign': 'https://imgdrop.imgix.net/8d1546748e9349c986aa73fd1eff1084.png',
  'Search-Homes': 'https://imgdrop.imgix.net/a0126a95c90d43ca924ca139bfb38ca0.png',
  'Map-Home': 'https://imgdrop.imgix.net/f3a8a92cbc084d79800492d4cbc82621.png',
  'Envelope-Document': 'https://imgdrop.imgix.net/7fc6be69a3a543c3b7f90360e9529fcf.png',
  'Video Walkthrough': 'https://imgdrop.imgix.net/00cdaaa5129b42e586db4ba1b2ba39d6.png',
  Apartment: 'https://imgdrop.imgix.net/ecd3de75e4da4d2695512130893d8503.png',
  Renovate: 'https://imgdrop.imgix.net/5a883d23a5594e3ea74c8581351e8d3b.png',
  'House-PriceUp': 'https://imgdrop.imgix.net/348242e2346742bf89db48817d8a23b4.png',
  'House-Worth': 'https://imgdrop.imgix.net/5704fae522c5454398837ea8f6d80ab1.png'
});
var HERO_IMAGE_DATA = (cov_16hnvlryli().s[5]++, {
  'Housing Appreciation 1': 'https://imgdrop.imgix.net/dda1dc2a57aa44848754060aa671a5bc.png',
  'Housing Appreciation 2': 'https://imgdrop.imgix.net/bbe86b096c03488182c7905caf67d515.png',
  'Use Location': 'https://imgdrop.imgix.net/c71a7b4766024b1988983cbe5c694225.png',
  'Calculate House Worth': 'https://imgdrop.imgix.net/4a04d234402b46e4945343833364074a.png',
  'Moving Homes 1': 'https://imgdrop.imgix.net/7748a626b46848fdb84724ad9547eb5a.png',
  'Moving Homes 2': 'https://imgdrop.imgix.net/bb322dffc0784f85b48b721f62d7d7d8.png',
  'Housing Appreciation 3': 'https://imgdrop.imgix.net/e4ee39c4c44d472192e8801eddfa0ad0.svg'
});
var MIX_MATCH_IMAGE_DATA = (cov_16hnvlryli().s[6]++, {
  'People/Celebrate-1': 'https://imgdrop.imgix.net/746aea8d6be74a8a9b5292687cb76bb5.png',
  'People/Celebrate-2': 'https://imgdrop.imgix.net/796573f5e3914d58a5c0381963136430.png',
  'People/Celebrate-3': 'https://imgdrop.imgix.net/bbb0e6e522e74995a4eec5e08b49d651.png',
  'People/Celebrate-4': 'https://imgdrop.imgix.net/208f8da9a44b4293ab7ddcdecfe13169.png',
  'People/Celebrate-5': 'https://imgdrop.imgix.net/2cb39d442db04473a93c2be7cb838374.png',
  'People/Celebrate-6': 'https://imgdrop.imgix.net/22a35ea64a1442debf1c9977d537bd9d.png',
  'People/Multi-1': 'https://imgdrop.imgix.net/b9fb98862d6149ab9678bea6f4831e72.png',
  'People/Multi-2': 'https://imgdrop.imgix.net/3fe28c2ec2d84b39aa4beed7111534ce.png',
  'People/Multi-3': 'https://imgdrop.imgix.net/1de6789f178341f4bc9de8f6b5d83b79.png',
  'People/Multi-4': 'https://imgdrop.imgix.net/a56f2f24a871425b8d96b7404ba37fa4.png',
  'People/Dog': 'https://imgdrop.imgix.net/7e190567883140ff924d3d69cf59499e.png',
  'People/UI-1': 'https://imgdrop.imgix.net/adb7e5d2b3fc40e098430f4a463e56b7.png',
  'People/UI-2': 'https://imgdrop.imgix.net/308e53e2d5cf41c780f0e5049239d5d4.png',
  'People/UI-3': 'https://imgdrop.imgix.net/079adda788f14aab9a5190d11ef3bf7e.png',
  'People/UI-4': 'https://imgdrop.imgix.net/12d4bbbbef0c456d9f42c48fe869b46c.png'
});
var EMPTY_STATE_IMAGE_DATA = (cov_16hnvlryli().s[7]++, {
  'Home 1': 'https://imgdrop.imgix.net/fcefabb804c64a769fec8ae2ab4ad74c.svg',
  'Home 2': 'https://imgdrop.imgix.net/b30ca61180c54834ab6955a9494f3d4f.svg',
  'Home 3': 'https://imgdrop.imgix.net/ea7890e73bce4051b7baf064d2680cca.svg',
  'Home 4': 'https://imgdrop.imgix.net/e9312b543d984d7380e42b60a287f3c0.svg'
});
export var IMAGE_DATA = (cov_16hnvlryli().s[8]++, {
  spot: SPOT_IMAGE_DATA,
  hero: HERO_IMAGE_DATA,
  mixMatch: MIX_MATCH_IMAGE_DATA,
  emptyState: EMPTY_STATE_IMAGE_DATA
});
cov_16hnvlryli().s[9]++;
export var Illustration = function Illustration(_ref) {
  var type = _ref.type,
      illustrationName = _ref.illustrationName,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_16hnvlryli().f[0]++;
  var src = (cov_16hnvlryli().s[10]++, React.useMemo(function () {
    var _ref2, _IMAGE_DATA$type;

    cov_16hnvlryli().f[1]++;
    cov_16hnvlryli().s[11]++;
    return (_ref2 = (cov_16hnvlryli().b[0][0]++, IMAGE_DATA === null || IMAGE_DATA === void 0 ? void 0 : (_IMAGE_DATA$type = IMAGE_DATA[type]) === null || _IMAGE_DATA$type === void 0 ? void 0 : _IMAGE_DATA$type[illustrationName])) !== null && _ref2 !== void 0 ? _ref2 : (cov_16hnvlryli().b[0][1]++, '');
  }, [illustrationName, type]));
  cov_16hnvlryli().s[12]++;
  return /*#__PURE__*/React.createElement(Image, _extends({
    alt: "",
    src: src
  }, props));
};